import { URL_SELECTION_ITEM_PROPOSAL_CREATE, URL_SELECTION_ITEM_REMOVE, URL_SELECTION_ITEM_RESTORE } from '@tools/routes/routes';
import { flashBagError } from '@tools/flashbag';
import { Requests } from '@tools/requests';
import { Logger } from '@tools/logger/logger';
import type { PipedriveUser } from '@models/auth/pipedriveUser';

export interface RemoveSelectionItemParams {
  selectionItemId: number;
  refusalReasons?: string[];
  refusedByUser?: boolean;
}

export const apiRemoveSelectionItem = async ({
  selectionItemId,
  refusalReasons = [],
  refusedByUser = true,
}: RemoveSelectionItemParams): Promise<boolean> => {
  try {
    await Requests.delete(URL_SELECTION_ITEM_REMOVE.replace('{id}', String(selectionItemId)), JSON.stringify({
      selectionItemId,
      refusalReasons,
      refusedByUser,
    }));
    return true;
  } catch (error) {
    flashBagError();
    Logger.error(error);
  }
  return false;
};

interface RestoreSelectionItemResponse {
  displayOrder: number;
}

export const apiRestoreSelectionItem = async (selectionItemId: number): Promise<RestoreSelectionItemResponse | null> => {
  try {
    const { data } = await Requests.post(URL_SELECTION_ITEM_RESTORE.replace('{id}', String(selectionItemId)));
    return data;
  } catch (error) {
    flashBagError();
    Logger.error(error);
  }

  return null;
};

interface CreateSelectionItemProposalParams {
  comment: string,
}

interface CreateSelectionItemProposalResponse {
  proposalId: number,
  pipedriveUser: PipedriveUser,
}

export const apiCreateSelectionItemProposal = async (
  selectionItemId: number,
  params: CreateSelectionItemProposalParams,
): Promise<CreateSelectionItemProposalResponse | null> => {
  try {
    const { data } = await Requests.post(
      URL_SELECTION_ITEM_PROPOSAL_CREATE.replace('{id}', String(selectionItemId)),
      params,
    );

    return data as CreateSelectionItemProposalResponse;
  } catch (error) {
    Logger.error(error);
  }

  return null;
};
